<template>
  <div class="resources-detail scene-content">
    <i
      class="iconfont iconguanbianniu2 close-resource"
      v-if="!isSearchAll"
      @click="closeSceneLib"
    ></i>
    <search
      v-if="!isSearchAll"
      v-model="searchVal"
      :searchAction="searchAction"
      :placeholderText="'搜索场景'"
      :isFocused="isFocused"
      @onFocus="onFocusAction"
    ></search>
    <div class="pad-14" v-if="!isSearchAll && !isFocused">
      <resouceTab @chooseTab="chooseTab" :currentType="currentTab"></resouceTab>
      <resourceFilters
        @chooseOneFilter="chooseOneFilter"
        :filterProps="filterProps"
        :currentTab="currentTab"
      ></resourceFilters>
    </div>
    <ul
      class="scenes visual-scene-lists"
      v-show="lists.length"
      :ref="moduleName"
      :class="isSearchAll ? 'Mixed' : filterProps.theFormat"
      @scroll="ulScroll($event)"
    >
      <li
        v-for="(item, index) in lists"
        :class="['direction-' + item.direction]"
        :style="isSearchAll ? (bricks[index] || {}).style : {}"
        :key="'template' + index"
        :title="item.hoverCommercial ? '可商用' : ''"
        @click="addScene({ id: item.id })"
      >
        <div
            class="li-inner"
            :style="{'background-image': `url(${$handleAssetsUrl(item.thumbnailUrl)})`}"
            @mouseenter.self="enterItem(item, index)"
            @mouseleave.self="leaveItem(index)"
          >
            <video muted="true" :ref="'myvideo' + index"></video>
            <div class="right-top-controls">
              <div
                class="collect"
                :class="{ active: item.favorites || currentTab === 'collect' }"
                @click.stop="collectAction(item, $event)"
              >
                <i class="iconfont iconshoucang1"></i>
              </div>
            </div>
            <div class="right-bottom-controls">
              <i
                class="business"
                v-if="item.isCommerical"
                @mouseenter.self.stop="item.hoverCommercial = true"
                @mouseleave.self.stop="item.hoverCommercial = false"
              ></i>
              <materialPayTypeSubscript :item="item"></materialPayTypeSubscript>
            </div>
          </div>
      </li>
      <globalSearchEntry
        :searchingText="searchVal"
        :listLen="lists.length"
        :listEl="$refs[moduleName]"
      ></globalSearchEntry>
    </ul>
    <loading
      :searchingProps="searchingProps"
      v-show="!lists.length && requestLoading"
    ></loading>
    <empty
      :searchingProps="searchingProps"
      v-show="!lists.length && !requestLoading"
    >
      <template #btn>
        <resourceFeedback></resourceFeedback>
        <globalSearchEntry
          :searchingText="searchVal"
          :listLen="1"
          :listEl="null"
          :buttonText="'全局搜索'"
          :buttonStyle="{height: '36px'}"
          style="width: 212px; margin-left: 0; margin-bottom: 10px; height: 36px;"
        ></globalSearchEntry>
      </template>
    </empty>
    <btnOpenLib
      v-if="currentTab === 'all' && !isFocused && !isSearchAll"
      :resource="{
        type: 'scene',
        text: '场景',
        nav: 'scene',
        category: filterProps.theCategory.id,
      }"
    ></btnOpenLib>
  </div>
</template>
<script >
import { mapGetters, mapMutations } from 'vuex';
import sceneTemplateMixins from '../mixins/resourcesArea/sceneTemplateMixins';
import globalSearchEntry from './globalSearchEntry.vue';
import btnOpenLib from './btnOpenLib.vue';
import vipBadge from '@/components/mixins/vipBadge';

export default {
  name: 'SceneContent',
  mixins: [sceneTemplateMixins, vipBadge],
  components: {
    globalSearchEntry,
    btnOpenLib
  },
  data () {
    return {
      moduleName: 'scene',
      filterProps: {
        allMemberLevels: [{
          name: '全部',
          level: ''
        }, {
          name: '免费',
          level: 'free'
        }, {
          name: '会员专属',
          level: 'person'
        }, {
          name: '企业会员专属',
          level: 'company'
        }]
      },
      bricks: [],
      bricksHeight: 0
    }
  },
  computed: {
    ...mapGetters(["SelectScenes_Msg", 'IsOldUser']),
    ...mapGetters({
      soundHandle: "addSoundtrack/getPlayHandle",
      subtitleObj: "subtitle/subtitleObj",
      WorksName: 'WorksName',
      WorksId: 'WorksId',
      subtitleEditor: "subtitle/subtitleEditor",
    }),
    vipScreen () {
      if (this.IsOldUser) {
        return [
          { name: "全部", level: null },
          { name: "免费", level: "free" },
          // { name: "付费", level: "pay" },
          { name: "会员专属", level: "person" },
          { name: "企业会员专属", level: "company" },
        ]
      }
      return [
        { name: "全部", level: null },
        { name: "免费", level: "free" },
        // { name: "付费", level: "pay" },
        { name: this.getOptionName(6), level: "company" },
        { name: this.getOptionName(4), level: "person" },
      ]
    },
  },
  created () {
    if (this.isSearchAll) {
      this.getLists({ type: 'reload' });
    }
    this.filterProps.allMemberLevels = this.vipScreen;
  },
  watch: {
    lists () {
      if (!this.isSearchAll) {
        return;
      }
      let l = 5;
      let gap = 10
      let brick = {
        w: 126,
        h: 70.88,
        hh: 224
      };
      let heights = [];
      this.bricks = this.lists.map((v, i) => {
        let obj = {};
        let dir = v.direction;
        let h = dir === 2 ? brick.hh : brick.h;
        if (i < 2) {
          obj.top = 0;
          obj.left = l + (brick.w + gap) * i;
          heights[i] = h;
        } else {
          let minHeight = heights[0];
          let index = 0;
          for (let j = 0; j < heights.length; j++) {
            if (minHeight > heights[j]) {
              minHeight = heights[j];
              index = j;
            }
          }
          obj.top = minHeight + gap;
          obj.left = l + (brick.w + gap) * index;
          heights[index] = heights[index] + gap + h;
        }

        obj.style = {
          position: 'absolute',
          top: obj.top + 'px',
          left: obj.left + 'px'
        }

        return obj;
      })
    }
  },
  mounted () {
    this.$bus.on('collect-scene-sucess', (data) => {
      this.chooseTab('collect');
    });
  },
  beforeDestroy () {
    this.$bus.off('collect-scene-sucess', (data) => {
      this.chooseTab('collect');
    });
  },
  methods: {
    ...mapMutations({
      setSceneLibStatus: "materialArea/setSceneLibStatus"
    }),
    async addScene ({ id }) {
      let dataMsg = { type: 12, id };
      // dataMsg.draftId = window.location.hash.slice(2);
      let res = await this.search({
        params: dataMsg
      })
      let scenesJson = null;
      let scale = 1;
      if(res.data[0].data.endsWith('.json')) {
        // 兼容老数据
        const jsonUrl = res.data[0].data;
        scenesJson = await (await fetch(this.$handleAssetsUrl(jsonUrl))).json();
      } else {
         scenesJson = JSON.parse(res.data[0].data);
      }
      if (scenesJson.if) {
        this.$modal.show("MessageDialog", {
          // title: "提示",
          content:
            "内测版编辑器收藏的场景页，暂不支持在旧版编辑器打开使用。",
          btns: ["Ok"],
          // resultHandler: (type) => {
          //   console.log(`Turbo ~ addScene ~ type`, type)

          // },
        });
        return;
      }
      console.log(`Turbo ~ addScene ~ scenesJson`, scenesJson)
      delete scenesJson.FT;
      (scenesJson.sprites || []).forEach(v => {
        v && delete v.FT;
      });
      scenesJson.resourceId = dataMsg.id;
      scale = this.TOOL.clientWidth / (scenesJson.resolution ? scenesJson.resolution.width : 1920);
      this.$store.commit("del_vipSprites", {
        id: "BG-" + this.SelectScenes_Msg.id
      });
      delete scenesJson.exitEffect;
      // 配音添加
      let addSounds = [];
      let changeTime = [0, 0, 0];
      let scenes = this.TOOL.sprites;
      for (let i = 0; i < scenes.length; i++) {
        if (scenes[i].id === this.SelectScenes_Msg.id) {
          changeTime[1] = changeTime[0] + this.SelectScenes_Msg.duration / 1000;
          changeTime[2] = changeTime[0] + scenesJson.duration;
          break;
        }
        changeTime[0] += (scenes[i].duration / 1000);
      }
      // 兼容老项目数据
      if (!scenesJson.dubbing && scenesJson.sound) {
        let sound = scenesJson.sound[0];
        let music = {
          id: sound.resourceId,
          title: sound.title,
          fileType: sound.fileType,
          url: sound.url,
          cut: [sound.startTime, sound.endTime],
          timeSlot: [changeTime[0], changeTime[2]]
        }
        let duration = await this.loadSound(sound.url);
        if (duration > 0.3) {
          if (!sound.endTime) {
            music.cut = [0, duration];
          }
          music.timeSlot[1] = music.timeSlot[0] + Math.min(music.cut[1] - music.cut[0], scenesJson.duration);
          addSounds.push(music);
        }
      }
      if (scenesJson.dubbing) {
        let dub = null;
        for (let i = 0; i < scenesJson.dubbing.length; i++) {
          dub = scenesJson.dubbing[i];
          addSounds.push({
            id: dub.resourceId,
            title: dub.title,
            fileType: dub.fileType,
            url: dub.url,
            timeSlot: [changeTime[0] + dub.timeSlot[0], changeTime[0] + dub.timeSlot[1]],
            cut: [...dub.cut]
          })
        }
      }
      let addSubtitles = [];
      if (scenesJson.subtitles) {
        let sub = null;
        for (let i = 0; i < scenesJson.subtitles.length; i++) {
          sub = scenesJson.subtitles[i];
          addSubtitles.push(Object.assign({}, sub, {
            startTime: changeTime[0] + sub.startTime,
            endTime: changeTime[0] + sub.endTime
          }))
        }
      }
      if (scenesJson.subtitles && !Object.keys(this.subtitleObj || {}).length) {
        this.$store.commit("subtitle/setSubtitleObj", {
          id: this.WorksId,
          title: this.WorksName,
          url: "",
          type: "draft",
          productionPlatform: "web",
          duration: this.TOOL.getDuration() / 1000,
          optimized: this.TOOL.optimized,
          resolution: {
            height: 1080.0,
            width: 1920.0,
          },
          contents: [],
        });
        this.subtitleEditor.loadUI(this.subtitleObj);
        this.subtitleEditor.setOption({
          width: this.TOOL.clientWidth,
          height: this.TOOL.clientHeight,
          rootId: "subtitle-player-9999",
        });
      }
      let undoDubbing = this.soundHandle.getDubbingTS(changeTime);
      let subtitles = []
      this.$store.commit('subtitle/getSubtitleTS', {timeSlot: changeTime, subtitles});
      this.soundHandle.updateScenesSound(changeTime, addSounds);
      this.$store.commit('subtitle/updateScenesSound', { changeTime, subtitles: addSubtitles });
      let dubbingData = {
        dubbing: addSounds,
        undoDubbing: undoDubbing
      }
      let subtitleData = {
        subtitles: addSubtitles,
        undoSubtitles: subtitles
      }

      this.SelectScenes_Msg.toFromJson(scenesJson, scale, true, {
        dubbingData,
        subtitleData
      }).then(() => {
        scenesJson = null;
        this.$bus.emit("timeline_update_totaltime", { data: "scenes" });
        // 商用相关
        this.$bus.emit("judgeItemPayType_vue", {
          type: "scenes",
          id: this.SelectScenes_Msg.id,
          option: {
            resourceId: dataMsg.id, // 背景资源id
            fileType: 24 // 背景资源type
          },
          opHelper: {
            isSvip: false
          },
          scenesId: this.SelectScenes_Msg.id
        });
        this.setRecent({
          type: this.moduleName,
          id
        });
      });
    },
    loadSound (src) {
      let audioEle = document.createElement('audio');
      audioEle.src = this.$handleAssetsUrl(src);

      return new Promise(function (resolve) {
        let t = setTimeout(() => {
          resolve(0);
        }, 10000);
        audioEle.onloadedmetadata = () => {
          resolve(audioEle.duration);
          audioEle.onloadedmetadata = null;
          audioEle = null;
        }
        audioEle.onerror = () => {
          resolve(0);
        }
      })
    },
    closeSceneLib () {
      this.setSceneLibStatus('pack-leave');
      this.$emit('changePackIndex', 16);
    }
  }
}
</script>
<style lang="scss" scoped>
.resources-detail {
  .scenes {
    li {
      .right-bottom-controls {
        .business {
          display: none;
        }
        .materialPayTypeSubscript {
          display: block;
        }
      }
      .right-top-controls {
        display: none;
      }
      &:hover {
        .right-bottom-controls {
          .business {
            display: block;
          }
          .materialPayTypeSubscript {
            display: none;
          }
        }
        .right-top-controls {
          display: flex;
        }
      }
    }
    &.Mixed {
      margin-bottom: 100px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/resourcesArea/sceneContent.vue